import React from "react";
import { View, Text, Platform } from "react-native";
import { Button, Modal } from "../../components";

interface AttemptLeftModalProps {
  assessmentResult: {
    score: number;
  };
  onCloseModal: () => void;
  onCloseAssessment: () => void;
  visible: boolean;
}

const Footer = ({ onCloseModal, onCloseAssessment }: { onCloseModal(): void; onCloseAssessment(): void }) => {
  return (
    <View className={`${Platform.OS === "web" ? "mx-16" : "mx-4"} mb-8 mt-2`}>
      <Button onPress={onCloseModal} className="w-full bg-primary-lightest mb-2">
        Try Again
      </Button>
      <Button mode="text" onPress={onCloseAssessment} className="w-full">
        Exit, I'll Try Again Later
      </Button>
    </View>
  );
};

export const AttemptLeftModal: React.FC<AttemptLeftModalProps> = ({
  assessmentResult,
  onCloseModal,
  onCloseAssessment,
  visible,
}) => {
  return (
    <Modal
      {...{
        visible,
        onDismiss: onCloseModal,
        title: "",
        fullScreen: false,
        FooterComponent: <Footer onCloseModal={onCloseModal} onCloseAssessment={onCloseAssessment} />,
      }}
    >
      <View className="flex-1 justify-between bg-white pt-8 mx-16 mt-10">
        <View className="flex-1 justify-center items-center">
          <Text className="text-title-4 font-700 text-center">Score: {assessmentResult.score}%</Text>
          <Text className="text-regular-normal font-700 text-center mb-4">Minimum Score Not Achieved.</Text>
          <Text className="text-regular-normal text-center mb-4">A score of 70% or higher is required to earn PDR Credit.</Text>
          <Text className="text-regular-normal text-center mb-4">
            A maximum of 2 attempts are permitted. If a passing score is not achieved on either attempt, no PDR Credits will be
            earned.
          </Text>
          <Text className="text-regular font-700 text-center mb-2 mt-16">1 Attempt Remaining</Text>
        </View>
      </View>
    </Modal>
  );
};
